/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export const isNumeric = (value: string | number) => {
  if (typeof value === 'number') {
    return true;
  }
  return !isNaN(+value) && !isNaN(parseFloat(value));
};
